import { useState } from 'react';
import './ImageScroller.scss';
import Slider from 'react-slick';
import { SliderSettings } from '@app/types/slick-slider.type';

export default function ImageScroller({
    media,
}: {
    media: { isVideo: boolean; src: string }[];
}) {
    const [current, setCurrent] = useState(0);

    const slidesCount = media.length > 4 ? 4 : media.length;
    const settings: SliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: slidesCount,
        swipeToSlide: true,
        vertical: true,
        verticalSwiping: true,
        nextArrow: <></>,
        prevArrow: <></>,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                },
            },
        ],
    };

    function choose(i: number): void {
        setCurrent(i);
    }

    return (
        <>
            {media.length ? (
                <div className="imageScroller">
                    <div className="imageScroller_scroller">
                        <Slider {...settings}>
                            {media.length
                                ? media.map((file, i) => (
                                      <figure
                                          key={`scroller source #${i}`}
                                          onClick={() => choose(i)}>
                                          {file.isVideo ? (
                                              <video
                                                  src={file.src}
                                                  autoPlay
                                                  muted></video>
                                          ) : (
                                              <img src={`${file.src}`} />
                                          )}
                                      </figure>
                                  ))
                                : ''}
                        </Slider>
                    </div>

                    <figure className="imageScroller_current">
                        {media[current].isVideo ? (
                            <video
                                src={media[current].src}
                                autoPlay
                                muted></video>
                        ) : (
                            <img src={`${media[current].src}`} />
                        )}
                    </figure>
                </div>
            ) : (
                ''
            )}
        </>
    );
}
